import Event from 'ol/events/Event';
import OLModify from 'ol/interaction/Modify.js';
import {createElement, forwardRef} from 'react';

/**
 * Custom extension of the interaction so that we can customize cursor and other things
 */
class ExplorerModify extends OLModify {
  handlePointerMove_(evt) {
    super.handlePointerMove_(evt);
    const overFeature = !!this.vertexFeature_;
    if (this.lastState !== overFeature) {
      this.dispatchEvent(
        new Event(overFeature ? 'mouseenter' : 'mouseleave', evt)
      );
    }
    this.lastState = overFeature;
  }

  removePoint() {
    // fake the down event to make the "grabber" work
    //  on the vertex.
    this.handleDownEvent({
      coordinate: this.lastPointerEvent_.coordinate_,
      pixel: this.lastPointerEvent_.pixel_,
      map: this.map_,
      force_: true,
    });
    super.removePoint();
  }
}

const ModifyInteraction = forwardRef((props, ref) => {
  return createElement('interaction', {cls: ExplorerModify, ref, ...props});
});

export default ModifyInteraction;
